// import React, { useEffect, useState, useRef } from "react";
// import { collection, query, getDocs, updateDoc, doc } from "firebase/firestore";
// import { db } from "../../firebase";
// import css from "./adm.module.css";

// // const OrderList = () => {
// //     const [orders, setOrders] = useState([]);
// //     const [selectedOrder, setSelectedOrder] = useState(null);
// //     const [editingStatusId, setEditingStatusId] = useState(null);
// //     const statusInputRef = useRef(null);

// //     useEffect(() => {
// //       const fetchOrders = async () => {
// //         const ordersRef = collection(db, 'orders');
// //         const querySnapshot = await getDocs(ordersRef);

// //         const parsedData = [];
// //         querySnapshot.forEach((doc) => {
// //           const order = { id: doc.id, ...doc.data() };
// //           const choice = JSON.parse(order.choice);
// //           parsedData.push({ order, choice });
// //         });

// //         setOrders(parsedData);
// //       };

// //       fetchOrders();
// //     }, []);

// //     const handleStatusDoubleClick = (orderId) => {
// //       setEditingStatusId(orderId);
// //     };

// //     const handleStatusChange = async (orderId, newStatus) => {
// //       const orderDocRef = doc(db, 'orders', orderId);
// //       await updateDoc(orderDocRef, { status: newStatus });

// //       setOrders((prevOrders) =>
// //         prevOrders.map((order) => {
// //           if (order.order.id === orderId) {
// //             return { ...order, order: { ...order.order, status: newStatus } };
// //           }
// //           return order;
// //         })
// //       );
// //     };

// //     const handleStatusBlur = () => {
// //       setEditingStatusId(null);
// //     };

// //     const handleOrderClick = (order) => {
// //       setSelectedOrder(order);
// //     };

// //     useEffect(() => {
// //       if (editingStatusId === selectedOrder?.order.id && statusInputRef.current) {
// //         statusInputRef.current.focus();
// //       }
// //     }, [editingStatusId, selectedOrder]);

// //     return (
// //       <div>
// //         {orders.map((orderItem) => (
// //           <div key={orderItem.order.id} onClick={() => handleOrderClick(orderItem)}>
// //             <p>{orderItem.order.uid}</p>
// //             {editingStatusId === orderItem.order.id ? (
// //               <input
// //                 type="text"
// //                 value={orderItem.order.status}
// //                 onChange={(e) => handleStatusChange(orderItem.order.id, e.target.value)}
// //                 onBlur={handleStatusBlur}
// //                 ref={statusInputRef}
// //               />
// //             ) : (
// //               <p onDoubleClick={() => handleStatusDoubleClick(orderItem.order.id)}>{orderItem.order.status}</p>
// //             )}
// //             {selectedOrder === orderItem && (
// //               <div>
// //                 {orderItem.choice.map((tovar) => (
// //                   <div key={tovar.id}>
// //                     <p>{tovar.name}</p>
// //                     <p>{tovar.price}</p>
// //                   </div>
// //                 ))}
// //               </div>
// //             )}
// //           </div>
// //         ))}
// //       </div>
// //     );
// //   };

// //   export default OrderList;
// const OrderList = () => {
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [editingStatusId, setEditingStatusId] = useState(null);
//   const [selectedUid, setSelectedUid] = useState(null);
//   const statusInputRef = useRef(null);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       const ordersRef = collection(db, "orders");
//       const querySnapshot = await getDocs(ordersRef);

//       const parsedData = [];
//       querySnapshot.forEach((doc) => {
//         const order = { id: doc.id, ...doc.data() };
//         const choice = JSON.parse(order.choice);
//         parsedData.push({ order, choice });
//       });

//       setOrders(parsedData);
//     };

//     fetchOrders();
//   }, []);

//   const handleStatusDoubleClick = (orderId) => {
//     if (editingStatusId === orderId) {
//       // Close status input if already editing
//       setEditingStatusId(null);
//     } else {
//       // Start editing status
//       setEditingStatusId(orderId);
//     }
//   };

//   const handleStatusChange = async (orderId, newStatus) => {
//     const orderDocRef = doc(db, "orders", orderId);
//     await updateDoc(orderDocRef, { status: newStatus });

//     setOrders((prevOrders) =>
//       prevOrders.map((order) => {
//         if (order.order.id === orderId) {
//           return { ...order, order: { ...order.order, status: newStatus } };
//         }
//         return order;
//       })
//     );
//   };

//   const handleStatusBlur = () => {
//     setEditingStatusId(null);
//   };

//   const handleOrderClick = (order) => {
//     if (selectedOrder === order) {
//       setSelectedOrder(null);
//       setSelectedUid(null);
//     } else {
//       setSelectedOrder(order);
//       setSelectedUid(order.order.uid);
//     }
//   };

//   useEffect(() => {
//     if (editingStatusId === selectedOrder?.order.id && statusInputRef.current) {
//       statusInputRef.current.focus();
//     }
//   }, [editingStatusId, selectedOrder]);

//   return (
//     <div className={css.orderListAllWrap}>
//       {orders.map((orderItem, index) => (
//         <div className={css.wrapAllAll} key={index}>
//           <div
//             className={css.orderWrapListinAdm}
//             onClick={() => handleOrderClick(orderItem)}
//           >
//             <p className={css.pOrderParag}>{orderItem.order.uid}</p>
//             {editingStatusId === orderItem.order.id ? (
//               <input
//                 type="text"
//                 value={orderItem.order.status}
//                 onChange={(e) =>
//                   handleStatusChange(orderItem.order.id, e.target.value)
//                 }
//                 onBlur={handleStatusBlur}
//                 ref={statusInputRef}
//               />
//             ) : (
//               <p
//                 className={css.pOrderParag}
//                 onDoubleClick={() =>
//                   handleStatusDoubleClick(orderItem.order.id)
//                 }
//               >
//                 {orderItem.order.status}
//               </p>
//             )}
//           </div>
//           {selectedUid === orderItem.order.uid && (
//             <div>
//               {orderItem.choice.map((tovar, index) => (
//                 <div key={index}>
//                   <p className={css.pOrderParag}>
//                     Данні замовника: {orderItem.order.surName}{" "}
//                     {orderItem.order.name} {orderItem.order.fatherName}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Спосіб оплати: {orderItem.order.pay}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Телефон: {orderItem.order.phone}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Адрес доставки: {orderItem.order.cityName},{" "}
//                     {orderItem.order.selectedDepartment}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Новий користувач:{" "}
//                     {orderItem.order.isNewBuyer === true ? "так" : "ні"}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Статус оплати:{" "}
//                     {orderItem.order.paymentStatus === "false"
//                       ? "не оплачено"
//                       : "оплачено"}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Данні для відправки: {orderItem.order.surNameOtr}{" "}
//                     {orderItem.order.nameOtr} {orderItem.order.fatherNameOtr}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Загальна вартість замовлення: {orderItem.order.totalPrice}
//                   </p>
//                   <p className={css.pOrderParag}>
//                     Статус замовлення: {orderItem.status}
//                   </p>

//                   {editingStatusId === orderItem.order.id ? (
//                     <input
//                       type="text"
//                       value={orderItem.order.status}
//                       onChange={(e) =>
//                         handleStatusChange(orderItem.order.id, e.target.value)
//                       }
//                       onBlur={handleStatusBlur}
//                       ref={statusInputRef}
//                     />
//                   ) : (
//                     <p
//                       onDoubleClick={() =>
//                         handleStatusDoubleClick(orderItem.order.id)
//                       }
//                     >
//                       Статус замовлення: {orderItem.order.status}
//                     </p>
//                   )}
//                   <p>Деталі замовлення:</p>
//                   {orderItem.choice.map((el, index) => (
//                     <div key={index} className={css.prodDescWrap}>
//                       <p className={css.pOrderParag}>
//                         Назва книги: {el.bookName}
//                       </p>
//                       <p className={css.pOrderParag}>
//                         Кількість: {el.quantity}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default OrderList;
import React, { useEffect, useMemo, useRef, useState } from "react";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import styles from "./OrderList.module.css";

/** Фіксовані статуси */
const STATUS_OPTIONS = [
  "Очікує підтвердження",
  "Взято в роботу",
  "Підтверджено",
  "Комплектація",
  "Відправлено",
  "Доставлено",
  "Скасовано",
  "Повернення/обмін",
];

/** Розміри сторінки */
const PAGE_SIZES = [10, 25, 50];

export default function OrderList() {
  const [orders, setOrders] = useState([]); // [{ order, choice }]
  const [expanded, setExpanded] = useState({}); // { [orderId]: bool }

  // редагування статусу
  const [editingStatusId, setEditingStatusId] = useState(null);
  const [statusDraft, setStatusDraft] = useState("");
  const statusRef = useRef(null);

  // редагування ТТН
  const [editingTtnId, setEditingTtnId] = useState(null);
  const [ttnDraft, setTtnDraft] = useState("");
  const ttnRef = useRef(null);

  // фільтри/сортування
  const [sortDir, setSortDir] = useState("desc"); // дата: asc|desc
  const [statusPin, setStatusPin] = useState("Усі"); // який статус вивести зверху
  const [statusOnly, setStatusOnly] = useState(false); // якщо true — показувати лише обраний статус

  const [dateFrom, setDateFrom] = useState(""); // YYYY-MM-DD
  const [dateTo, setDateTo] = useState(""); // YYYY-MM-DD

  // пагінація
  const [page, setPage] = useState(1); // 1-based
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, "orders"));
      const rows = [];
      snap.forEach((d) => {
        const raw = { id: d.id, ...d.data() };
        let choice = [];
        try {
          if (Array.isArray(raw.choice)) choice = raw.choice;
          else if (typeof raw.choice === "string")
            choice = JSON.parse(raw.choice || "[]");
        } catch {
          choice = [];
        }
        rows.push({ order: raw, choice });
      });
      setOrders(rows);
    })();
  }, []);

  useEffect(() => {
    if (editingStatusId && statusRef.current) statusRef.current.focus();
  }, [editingStatusId]);
  useEffect(() => {
    if (editingTtnId && ttnRef.current) ttnRef.current.focus();
  }, [editingTtnId]);

  // скидати на 1 сторінку при зміні фільтрів/сортування/розміру
  useEffect(() => {
    setPage(1);
  }, [
    pageSize,
    sortDir,
    statusPin,
    statusOnly,
    dateFrom,
    dateTo,
    orders.length,
  ]);

  const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

  /* ======== ПІПЕЛАЙН ДАНИХ: фільтри -> сортування -> пагінація ======== */
  const filtered = useMemo(() => {
    let arr = [...orders];

    // фільтр за статусом (лише цей статус)
    if (statusOnly && statusPin !== "Усі") {
      arr = arr.filter(({ order }) => (order.status || "") === statusPin);
    }

    // фільтр за періодом (дата створення)
    if (dateFrom || dateTo) {
      const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
      const toMs = dateTo ? dayEnd(dateTo) : Infinity;
      arr = arr.filter(({ order }) => {
        const t = ts(order);
        return t >= fromMs && t <= toMs;
      });
    }

    return arr;
  }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

  // сортування:
  // — за датою (asc/desc)
  // — + якщо обрано конкретний статус (statusPin != "Усі") і НЕ режим "лише цей статус",
  //     то замовлення з цим статусом піднімаємо догори, а всередині груп — за датою.
  const sorted = useMemo(() => {
    const arr = [...filtered];
    const cmpDate = (a, b) => {
      const A = ts(a.order),
        B = ts(b.order);
      return sortDir === "asc" ? A - B : B - A;
    };

    if (statusPin !== "Усі" && !statusOnly) {
      arr.sort((a, b) => {
        const pa = (a.order.status || "") === statusPin ? 0 : 1;
        const pb = (b.order.status || "") === statusPin ? 0 : 1;
        if (pa !== pb) return pa - pb;
        return cmpDate(a, b);
      });
    } else {
      arr.sort(cmpDate);
    }
    return arr;
  }, [filtered, sortDir, statusPin, statusOnly]);

  /* ======== ПАГІНАЦІЯ ======== */
  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const pageClamped = Math.min(page, totalPages);
  const start = (pageClamped - 1) * pageSize;
  const end = start + pageSize;
  const paged = sorted.slice(start, end);

  const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

  /* ======== РЕДАГУВАННЯ СТАТУСУ ======== */
  const beginEditStatus = (o, e) => {
    e?.stopPropagation();
    setEditingStatusId(o.id);
    setStatusDraft(String(o.status || "Очікує підтвердження"));
  };
  const cancelEditStatus = () => {
    setEditingStatusId(null);
    setStatusDraft("");
  };
  const saveStatus = async (orderId) => {
    const v = statusDraft.trim();
    await updateDoc(doc(db, "orders", orderId), { status: v });
    setOrders((arr) =>
      arr.map((r) =>
        r.order.id === orderId ? { ...r, order: { ...r.order, status: v } } : r
      )
    );
    cancelEditStatus();
  };
  const onStatusKey = (e, orderId) => {
    if (e.key === "Enter") saveStatus(orderId);
    if (e.key === "Escape") cancelEditStatus();
  };

  /* ======== ТТН (Нова пошта) ======== */
  const canEditTTN = (order) =>
    ["Взято в роботу", "Відправлено", "Доставлено"].includes(
      order.status || ""
    );
  const beginEditTTN = (order) => {
    if (!canEditTTN(order)) return;
    setEditingTtnId(order.id);
    setTtnDraft(String(order.ttn || ""));
  };
  const cancelEditTTN = () => {
    setEditingTtnId(null);
    setTtnDraft("");
  };
  const saveTTN = async (orderId) => {
    const v = ttnDraft.trim();
    if (!/^\d{8,14}$/.test(v)) {
      alert("Введіть коректний номер ТТН (8–14 цифр).");
      return;
    }
    await updateDoc(doc(db, "orders", orderId), { ttn: v });
    setOrders((arr) =>
      arr.map((r) =>
        r.order.id === orderId ? { ...r, order: { ...r.order, ttn: v } } : r
      )
    );
    cancelEditTTN();
  };
  const onTtnKey = (e, orderId) => {
    if (e.key === "Enter") saveTTN(orderId);
    if (e.key === "Escape") cancelEditTTN();
  };

  return (
    <div className={styles.page}>
      <div className={styles.toolbar}>
        <h2 className={styles.title}>Замовлення</h2>

        <div className={styles.controls}>
          {/* ПЕРІОД ДАТИ */}
          <label className={styles.control}>
            <span>Період: з</span>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className={styles.input}
            />
          </label>
          <label className={styles.control}>
            <span>до</span>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className={styles.input}
            />
          </label>

          {/* СОРТУВАННЯ ДАТИ */}
          <label className={styles.control}>
            <span>Дата:</span>
            <select
              value={sortDir}
              onChange={(e) => setSortDir(e.target.value)}
              className={styles.select}
            >
              <option value="desc">спадання (нові зверху)</option>
              <option value="asc">зростання (старі зверху)</option>
            </select>
          </label>

          {/* «Сортування» по конкретному статусу */}
          <label className={styles.control}>
            <span>Статус вгорі:</span>
            <select
              value={statusPin}
              onChange={(e) => setStatusPin(e.target.value)}
              className={styles.select}
            >
              <option value="Усі">Усі</option>
              {STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </label>

          <label className={styles.controlCheck}>
            <input
              type="checkbox"
              checked={statusOnly}
              onChange={(e) => setStatusOnly(e.target.checked)}
            />
            <span>Показувати лише цей статус</span>
          </label>

          <label className={styles.control}>
            <span>На сторінці:</span>
            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className={styles.select}
            >
              {PAGE_SIZES.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.colCheck}></th>
              <th>Дата створення</th>
              <th>ID</th>
              <th>Покупець</th>
              <th>Статус</th>
              <th>Оплачено</th>
              <th>Скасовано</th>
              <th className={styles.colSum}>Сума</th>
              <th>Позиції</th>
            </tr>
          </thead>
          <tbody>
            {paged.map(({ order, choice }) => {
              const id = order.id;
              const isOpen = !!expanded[id];
              const paid = toBool(order.paymentStatus) ? "Так" : "Ні";
              const canceled = toBool(order.canceled) ? "Так" : "Ні";
              const sum = safeMoney(order.totalPrice);
              const buyer = fullName(
                order.surName,
                order.name,
                order.fatherName
              );

              return (
                <React.Fragment key={id}>
                  <tr
                    className={styles.row}
                    onDoubleClick={() => toggleExpand(id)}
                  >
                    <td className={styles.colCheck}>
                      <input type="checkbox" />
                    </td>
                    <td>{fmtDate(ts(order))}</td>
                    <td className={styles.idCell}>№{shortId(id)}</td>
                    <td className={styles.buyerCell}>{buyer || "—"}</td>

                    <td
                      className={styles.statusCell}
                      onDoubleClick={(e) => beginEditStatus(order, e)}
                    >
                      {editingStatusId === id ? (
                        <select
                          ref={statusRef}
                          value={statusDraft || "Очікує підтвердження"}
                          onChange={(e) => setStatusDraft(e.target.value)}
                          onBlur={() => saveStatus(id)}
                          onKeyDown={(e) => onStatusKey(e, id)}
                          className={styles.statusSelect}
                        >
                          {STATUS_OPTIONS.map((opt) => (
                            <option key={opt} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span className={styles.statusBadge}>
                          {order.status || "Очікує підтвердження"}
                        </span>
                      )}
                    </td>

                    <td>{paid}</td>
                    <td>{canceled}</td>
                    <td className={styles.colSum}>{sum}</td>
                    <td className={styles.positionsCell}>
                      {choice.length > 0 ? (
                        <>
                          {choice[0]?.bookName || choice[0]?.name || "Товар"}
                          {choice.length > 1 && (
                            <span className={styles.morePos}>
                              {" "}
                              +{choice.length - 1} поз.
                            </span>
                          )}
                        </>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>

                  {isOpen && (
                    <tr className={styles.detailsRow}>
                      <td></td>
                      <td colSpan={8}>
                        <div className={styles.detailsBox}>
                          <div className={styles.colLeft}>
                            <h4>Дані замовника</h4>
                            <p>
                              <b>ПІБ:</b> {buyer || "—"}
                            </p>
                            <p>
                              <b>Телефон:</b> {order.phone || "—"}
                            </p>
                            <p>
                              <b>Спосіб оплати:</b> {order.pay || "—"}
                            </p>
                            <p>
                              <b>Адреса доставки:</b> {order.cityName || "—"}
                              {order.selectedDepartment
                                ? ", " + order.selectedDepartment
                                : ""}
                            </p>
                            <p>
                              <b>Новий користувач:</b>{" "}
                              {toBool(order.isNewBuyer) ? "так" : "ні"}
                            </p>
                            <p>
                              <b>Статус оплати:</b>{" "}
                              {toBool(order.paymentStatus)
                                ? "оплачено"
                                : "не оплачено"}
                            </p>
                            {(order.surNameOtr ||
                              order.nameOtr ||
                              order.fatherNameOtr) && (
                              <p>
                                <b>Отримувач:</b>{" "}
                                {fullName(
                                  order.surNameOtr,
                                  order.nameOtr,
                                  order.fatherNameOtr
                                )}
                              </p>
                            )}
                            <p>
                              <b>Загальна вартість замовлення:</b> {sum}
                            </p>
                            <p>
                              <b>Статус замовлення:</b> {order.status || "—"}
                            </p>
                          </div>

                          <div className={styles.colRight}>
                            <h4>Логістика</h4>
                            <div className={styles.ttnRow}>
                              <b>ТТН Нової пошти:&nbsp;</b>
                              {editingTtnId === id ? (
                                <>
                                  <input
                                    ref={ttnRef}
                                    value={ttnDraft}
                                    onChange={(e) =>
                                      setTtnDraft(e.target.value)
                                    }
                                    onKeyDown={(e) => onTtnKey(e, id)}
                                    onBlur={() => saveTTN(id)}
                                    placeholder="Введіть номер ТТН (8–14 цифр)"
                                    className={styles.ttnInput}
                                  />
                                  <button
                                    type="button"
                                    className={styles.saveBtn}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => saveTTN(id)}
                                  >
                                    Зберегти
                                  </button>
                                  <button
                                    type="button"
                                    className={styles.cancelBtn}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={cancelEditTTN}
                                  >
                                    Скасувати
                                  </button>
                                </>
                              ) : order.ttn ? (
                                <>
                                  <a
                                    href={`https://tracking.novaposhta.ua/#/ua?cargo_number=${order.ttn}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={styles.ttnLink}
                                  >
                                    {order.ttn}
                                  </a>
                                  <button
                                    type="button"
                                    className={styles.editBtn}
                                    onClick={() => beginEditTTN(order)}
                                  >
                                    Змінити
                                  </button>
                                </>
                              ) : canEditTTN(order) ? (
                                <button
                                  type="button"
                                  className={styles.addBtn}
                                  onClick={() => beginEditTTN(order)}
                                >
                                  Додати ТТН
                                </button>
                              ) : (
                                <span>
                                  — (доступно після статусу «Взято в роботу»)
                                </span>
                              )}
                            </div>

                            <h4>Позиції ({choice.length})</h4>
                            {choice.length === 0 && (
                              <div className={styles.empty}>Позицій немає</div>
                            )}
                            {choice.map((el, i) => (
                              <div key={i} className={styles.item}>
                                <div className={styles.itemName}>
                                  {el.bookName || el.name || `Товар ${i + 1}`}
                                </div>
                                <div className={styles.itemQty}>
                                  x{el.quantity ?? 1}
                                </div>
                                {el.price ? (
                                  <div className={styles.itemPrice}>
                                    {safeMoney(el.price)}
                                  </div>
                                ) : (
                                  <div />
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Пагінація */}
      <div className={styles.paginator}>
        <button
          className={styles.pageBtn}
          onClick={() => goto(1)}
          disabled={pageClamped === 1}
        >
          « Перша
        </button>
        <button
          className={styles.pageBtn}
          onClick={() => goto(pageClamped - 1)}
          disabled={pageClamped === 1}
        >
          ‹ Назад
        </button>
        <span className={styles.pageInfo}>
          Сторінка {pageClamped} з {totalPages}
        </span>
        <button
          className={styles.pageBtn}
          onClick={() => goto(pageClamped + 1)}
          disabled={pageClamped === totalPages}
        >
          Вперед ›
        </button>
        <button
          className={styles.pageBtn}
          onClick={() => goto(totalPages)}
          disabled={pageClamped === totalPages}
        >
          Остання »
        </button>
      </div>
    </div>
  );
}

/* ===== Хелпери ===== */
function ts(order) {
  const t =
    order?.createdAt || order?.date || order?.created_at || order?.created;
  if (!t) return 0;
  if (typeof t === "number") return t;
  if (typeof t === "string") return Date.parse(t) || 0;
  if (t?.seconds)
    return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);
  try {
    return new Date(t).getTime();
  } catch {
    return 0;
  }
}
function fmtDate(ms) {
  if (!ms) return "—";
  const d = new Date(ms);
  return d.toLocaleString("uk-UA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
function fullName(sur, name, father) {
  return [sur, name, father].filter(Boolean).join(" ");
}
function toBool(v) {
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (typeof v === "string") return v.toLowerCase() === "true" || v === "1";
  return false;
}
function safeMoney(v) {
  const n = Number(v || 0);
  if (!isFinite(n)) return "—";
  return new Intl.NumberFormat("uk-UA", {
    style: "currency",
    currency: "UAH",
    maximumFractionDigits: 0,
  }).format(n);
}
function shortId(id = "") {
  return String(id).slice(-4);
}
function dayStart(yyyy_mm_dd) {
  const d = new Date(yyyy_mm_dd + "T00:00:00");
  return d.getTime();
}
function dayEnd(yyyy_mm_dd) {
  const d = new Date(yyyy_mm_dd + "T23:59:59.999");
  return d.getTime();
}
